import fetch, { doGet, doPost } from '../../tools/axios'

export default {
  getGeo (cb) {
    return fetch('get', '/geo', {}, cb)
  },
  getFami (cb) {
    return fetch('get', '/config/fami', {}, cb)
  },
  // 订阅关键字
  batchSubKeyW (keywords, cb) {
    const data = {
      keywords
    }
    return fetch('post', '/keywords/batch', {data}, cb)
  },
  // 获取订阅关键字
  getSubKeyW (cb) {
    return fetch('get', '/keywords', {}, cb)
  },
  // 获取用户身份类别
  getUserCategories (cb) {
    return fetch('get', '/categories?type=users', {}, cb)
  },
  // 获取好人点
  getBonusRank (cb) {
    return fetch('get', '/config/bonusRanking', {}, cb)
  },
  getShareUrl (data, cb) {
    return fetch('post', '/shares', {data}, cb)
  },
  getConfigVersions () {
    return doGet('/config/versions')
  },
  getConfigInfo (type) {
    return doGet('/config/info', {type})
  },
  getThingCategories () {
    return doGet('/categories?type=things')
  },
  getStoryCategories () {
    return doGet('/categories?type=storys')
  },
  getShareInfo (shareId) {
    return doGet(`/shares/${shareId}/info`)
  },
  getAgreementConfig () {
    return doGet('/page/configs/agreement')
  },
  getPrivacyConfig () {
    return doGet('/page/configs/privacy')
  },
  getAbout543Config () {
    return doGet('/page/configs/about543')
  },
  getPalmboxCouponInfo () {
    return doGet('/awards/1')
  },
  receivePalmboxCoupon () {
    return doPost('/awards/1/receive')
  },
  getMyCouponInfo () {
    return doGet('/my/awards')
  },
  getDefaultInvoiceDonate () {
    return doGet('/invoice/configs/defaultDonate')
  },
  getDormZoneSwitchState () {
    return doGet('/app/configs/dormZoneSwitch')
  },
  getItemCategories () {
    return doGet('/item-categories')
  }
}
